import React from 'react';
import { useTranslation } from 'react-i18next';

import { Chips, StyledCard } from '@p81-common/ui';
import { Heading, Text } from 'components/common/Elements/Elements';
import { renameOS } from 'utils/common';
import {
  PLATFORM_TRACK_SLOTS,
  RELEASE_TRACKS
} from '../../helpers/configurates';
import classes from './RecommendedVersions.module.scss';

type VersionBuild = {
  platform: string;
  version: string;
  releaseTracks?: string[];
};

type VersionLabelsProps = {
  labelledBuilds?: VersionBuild[];
  linuxBuilds?: VersionBuild[];
};

const RecommendedVersions = (props: VersionLabelsProps) => {
  const { labelledBuilds = [], linuxBuilds = [] } = props;
  const { t } = useTranslation(['activity']);

  const findVersion = (platform: string, slot: string) =>
    (RELEASE_TRACKS.includes(slot)
      ? labelledBuilds.find(
          build =>
            build.platform === platform &&
            (build.releaseTracks || []).includes(slot)
        )
      : linuxBuilds.find(build => build.platform === platform)
    )?.version || '';

  return (
    <StyledCard
      variant="outlined"
      indicator={false}
      disableInteractive
      className={classes.labelsCard}
    >
      <div className={classes.labelsHeader}>
        <Heading size={3} weight="m" className="">
          {t('activity:agentRollout.VERSION_LABELS_TITLE')}
        </Heading>
        <Text type="s" className="">
          {t('activity:agentRollout.VERSION_LABELS_HINT')}
        </Text>
      </div>
      <div className={classes.platformRow}>
        {Object.entries(PLATFORM_TRACK_SLOTS).map(([platform, slots]) => (
          <StyledCard
            key={platform}
            variant="outlined"
            indicator={false}
            disableInteractive
            className={classes.platformCard}
          >
            <Heading size={4} weight="m" className="">
              {renameOS(platform)}
            </Heading>
            {slots.map(slot => {
              const version = findVersion(platform, slot);

              return (
                <div className={classes.slotRow} key={slot}>
                  <Chips
                    label={t(`activity:agentRollout.RELEASE_TRACK_${slot}`)}
                    size="small"
                  />
                  <Text type="s" className="">
                    {version || t('activity:agentRollout.SLOT_NOT_ASSIGNED')}
                  </Text>
                </div>
              );
            })}
          </StyledCard>
        ))}
      </div>
    </StyledCard>
  );
};

export default RecommendedVersions;
